// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Icon, { IconProps } from "@insite/mobius/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import Mail from "@pacific/XDL/Icons/Mail";
import Phone from "@pacific/XDL/Icons/Phone";
import React, { FC } from "react";
import { css } from "styled-components";

type ContactType = "phone" | "email" | "branch" | "chat";
interface OwnProps {
    targetValue?: string;
    type: ContactType;
    icon?: boolean;
    iconProps?: IconProps;
}

type Props = OwnProps & TypographyProps;

const getType = (type: ContactType) => {
    let target = "";
    switch (type) {
        case "email":
            target = "mailto:";
            break;
        case "phone":
            target = "tel:";
            break;
    }
    return target;
};

const getIcon = (type: ContactType) => {
    let icon = Phone;
    switch (type) {
        case "email":
            icon = Mail;
            break;
        case "phone":
            icon = Phone;
            break;
    }
    return icon;
};

const ContactTypography: FC<Props> = ({ icon, iconProps, children, targetValue, type, ...otherProps }) => {
    const target = getType(type);
    const xProps = {
        href: `${target}${targetValue}`,
        ...otherProps,
    };

    return (
        <Typography
            as="a"
            {...xProps}
            css={css`
                ${icon &&
                css`
                    display: flex;
                    align-items: center;
                `}
                ${xProps?.css}
            `}
        >
            {icon && (
                <Icon
                    src={getIcon(type)}
                    size={12}
                    color="text.link"
                    {...iconProps}
                    css={css`
                        margin-right: 4px;
                        ${iconProps?.css}
                    `}
                />
            )}
            {children}
        </Typography>
    );
};

export default ContactTypography;
